@if (criteria.label) {
  <div data-cy="chip-toggle-filter-label" class="chip-toggle-filter__title search-filter-title">{{
    criteria.label
  }}</div>
}

<campus-chip-group>
  @for (criteriaValue of criteria.values; track criteriaValue) {
    @if (criteriaValue.visible !== false && criteriaValue.prediction !== 0) {
      <campus-filter-chip
        data-cy="chip-option"
        [selected]="criteriaValue.selected"
        (click)="selectCriteriaValue(criteriaValue)"
        [label]="criteriaValue.data[criteria.displayProperty]"
        >
      </campus-filter-chip>
    }
  }
</campus-chip-group>
